var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoMini = function SvgLogoMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FF155B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 21.02c0-1.593.275-3.1.826-4.52a11.01 11.01 0 0 1 2.393-3.739c1.043-1.072 2.305-1.927 3.784-2.565 1.479-.637 3.146-.956 5.002-.956 2.493 0 4.61.536 6.35 1.608 1.769 1.073 3.088 2.478 3.958 4.217l-5.698 1.74c-.493-.841-1.145-1.479-1.957-1.914-.812-.463-1.711-.695-2.697-.695-.84 0-1.624.174-2.349.521a5.605 5.605 0 0 0-1.913 1.391c-.522.58-.943 1.29-1.262 2.13-.29.841-.435 1.768-.435 2.783 0 1.014.16 1.942.479 2.782.319.84.74 1.565 1.261 2.174a6.15 6.15 0 0 0 1.914 1.434 5.663 5.663 0 0 0 2.305.479c1.044 0 2-.261 2.87-.783.9-.522 1.523-1.16 1.871-1.913l5.698 1.74c-.783 1.738-2.073 3.158-3.871 4.26-1.798 1.1-3.958 1.651-6.48 1.651-1.857 0-3.524-.318-5.003-.956-1.479-.638-2.74-1.493-3.784-2.565a12.093 12.093 0 0 1-2.436-3.782 12.617 12.617 0 0 1-.826-4.521Z",
    fill: "#fff"
  })));
};

export default SvgLogoMini;